export default {
  header: 'Verktøy',
  tabs: {
    qr: 'QR',
    abv: 'ABV',
    honey: 'Honning',
    bottleSlider: 'Flaske-slider',
  },
  totalLiters: 'Totalt liter',
  placeholderLiters: 'Skriv inn totalt antall liter',
  bottleSizes: 'Flaskestørrelser (L)',
  adjustSlider: 'Juster skyveknappen for å se hvor mange flasker du trenger.',
};
